import {
  __,
  always,
  append,
  assoc,
  complement,
  contains,
  curry,
  curryN,
  dissoc,
  either,
  eqProps,
  equals,
  findIndex,
  flatten,
  has,
  identity,
  ifElse,
  isEmpty,
  isNil,
  map,
  nAry,
  pipe,
  prop,
  reduce,
  reject,
  unless,
  update,
  values,
} from 'ramda';
import _round from 'lodash/round';
import some from 'lodash/fp/some';

export const renameProp = (oldName, newName) =>
  pipe(item => assoc(newName, prop(oldName, item), item), dissoc(oldName));

export const renamePropIfExists = (oldName, newName) => ifElse(has(oldName), renameProp(oldName, newName), identity);

export const dropItem = curry((item, list) => reject(equals(item))(list));

export const addItem = curry((item, list) => unless(contains(item), append(item))(list));

export const replaceItemInCollection = curryN(2, (item, list, key = 'id') => pipe(
  findIndex(eqProps(key, item, __)),
  update(
    __,
    item,
    list,
  )
)(list));

export const mapBySelector = curry((itemSelector, listSelector, state) =>
  map(itemSelector(state), listSelector(state)),
);

export const round = curry((number, precision) => _round(number, precision));

export const alwaysFinite = unless(isFinite, always(0));

export const isInstanceOfFile = obj => obj instanceof File;

export const isPropFileInstance = pipe(prop, isInstanceOfFile);

export const isHashMapEmpty = pipe(values, flatten, isEmpty);

const isNilOrEmpty = either(isNil, isEmpty);
export const mapEntries = curry((fn, obj) => {
  if (isNilOrEmpty(obj)) return [];
  return Object.entries(obj).map(entry => fn(...entry));
});

export const none = complement(nAry(2, some));

export const alwaysArray = value => (Array.isArray(value) ? value : [value]);

export const collectionTotal = (collection) => {
  if (!Array.isArray(collection)) return collection;
  return reduce(
    (acc, item) => {
      Object.keys(item).forEach((key) => {
        if (Number.isFinite(item[key])) {
          acc[key] = (acc[key] || 0) + item[key];
        }
      });
      return acc;
    },
    {},
    collection
  );
};
